import ProviderAPI from "../redux/ProviderAPI";

export const getPromotion = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "promotion/detailpromotion",
    data,
    token,
  });

  return result;
};

export const updateUsePromotion = async (promotion_code, token) => {
  const result = await ProviderAPI({
    type: "PUT",
    url: "promotion/usepromotion",
    data: { promotion_code },
    token,
  });

  return result;
};
